"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _linkaddress = _interopRequireDefault(require("@/components/linkaddress"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'c_home_comb_cards',
  props: {
    configObj: {
      type: Object
    },
    configNme: {
      type: String
    }
  },
  components: {
    linkaddress: _linkaddress.default
  },
  data: function data() {
    return {
      configData: null,
      activeIndex: 0
    };
  },
  watch: {
    configObj: {
      handler: function handler(nVal) {
        this.configData = nVal ? nVal[this.configNme] : null;
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    cardLabel: function cardLabel(item, index) {
      if (item.type === 'stats') return '左侧数据卡';
      return index === 1 ? '右上跳转卡' : '右下跳转卡';
    },
    pickLink: function pickLink(index) {
      this.activeIndex = index;
      this.$refs.linkaddres.dialogVisible = true;
    },
    pickMetricIcon: function pickMetricIcon(metric) {
      this.$modalUpload(function (img) {
        if (!img) return;
        metric.iconImage = img[0].sattDir;
      }, false, 'diy');
    },
    clearMetricIcon: function clearMetricIcon(metric) {
      metric.iconImage = '';
    },
    pickBadgeImage: function pickBadgeImage(item) {
      this.$modalUpload(function (img) {
        if (!img) return;
        item.badgeImage = img[0].sattDir;
      }, false, 'diy');
    },
    clearBadgeImage: function clearBadgeImage(item) {
      item.badgeImage = '';
    },
    linkUrl: function linkUrl(url) {
      this.configData.list[this.activeIndex].url = url;
    }
  }
};